import React, { useContext } from 'react'
import { useWeb3React } from '@web3-react/core'
import { allLanguages } from 'config/localisation/languageCodes'
import { LanguageContext } from 'contexts/Localisation/languageContext'
import useTheme from 'hooks/useTheme'
import useAuth from 'hooks/useAuth'
import { Menu as UikitMenu } from 'vontery-fishingtown-uikit'
import { usePriceCakeBusd } from 'state/hooks'
import config from './config'



const vonIcon = (<img src="/images/tokens/FHTN.png" alt='FHTN TOKEN'/>)

const Menu = (props) => {
  const { account } = useWeb3React()
  const { login, logout } = useAuth()
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext)
  const { isDark, toggleTheme } = useTheme()
  // const cakePriceUsd = useSelector((state: State) => state.prices.fhtnPrices)
  const cakePriceUsd = usePriceCakeBusd()
  return (
    <UikitMenu
      account={account}
      login={login}
      logout={logout}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={selectedLanguage && selectedLanguage.code}
      langs={allLanguages}
      setLang={setSelectedLanguage}
      cakePriceIcon={vonIcon}
      cakePriceUsd={cakePriceUsd}
      cakePriceRef="https://poocoin.app/tokens/0x87be0b856960f57fb0104ef0922cd1dacbd37f64"
      brandlogo="/fishingtown-logo.png"
      links={config}
      priceLink="#"
      {...props}
    />
  )
}

export default Menu
